const CodingSeniorWinnersList: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <section className="mb-8">
                <p className="mb-2">
                    Kompetisi <b>Coding Python Senior</b> dalam ajang <b>Indonesia Innovative Technology Challenge (IIT Challenge) 2024</b> telah menampilkan persaingan sengit di antara pelajar SMA berbakat.
                    Kategori ini menguji kemampuan peserta dalam menyelesaikan tantangan logika, algoritma, dan pemrograman Python dengan solusi yang efisien dan kreatif.
                </p>

                <p className="mb-2">Setelah persaingan ketat, berikut para pemenang yang berhasil mencatatkan prestasi gemilang:</p>

                <p className='mb-3'><b>🏆 Pemenang Coding Python Senior 2024</b></p>
                <ul className="list-disc pl-6 mb-4">
                    <li>🥇 Juara 1: Matthew Joshua Hartono, CCNA (Sekolah Dian Harapan Daan Mogot)</li>
                    <li>🥈 Juara 2: Farisi Achmad Al Banna (SMA Unggulan Rushd)</li>
                    <li>🥉 Juara 3: Darell Joaqim Triman Hasugian (SMA Kristen Yahya)</li>
                </ul>

                <p className="mb-4 font-semibold">Hadiah & Manfaat Eksklusif untuk Para Pemenang:</p>

                <p className='mb-3'>Selain medali dan sertifikat penghargaan, para pemenang berhak mendapatkan <b>benefit bernilai total ratusan juta rupiah</b>, termasuk:</p>

                <p className="mb-4 font-semibold">💻 Pelatihan Teknologi</p>

                <ul className="list-disc pl-6 mb-3">
                    <li>✅ Software Programming Bootcamp (2 Bulan) – Senilai Rp 26.550.000</li>
                    <li>✅ Robotic Race Workshop – Persiapan untuk WIT Challenge 2024</li>
                    <li>✅ Software Programming Workshop – Persiapan untuk WIT Challenge 2024</li>
                    <li>✅ Subsidi Biaya Pendaftaran WIT Challenge 2024</li>
                </ul>

                <p className="mb-3 font-semibold">🎓 Beasiswa UKRIDA</p>
                <ul className="list-disc pl-6 mb-4">
                    <li><b>Juara 1:</b> Beasiswa penuh (SPP + uang pangkal) hingga 8 semester di Teknik Elektro, Industri, atau Sipil (IPK ≥ 3.00). Prodi lain: Gratis uang pangkal + diskon 25% SPP.</li>
                    <li><b>Juara 2:</b> Gratis uang pangkal 100% untuk semua prodi.</li>
                    <li><b>Juara 3:</b> Diskon 70% uang pangkal untuk semua prodi.</li>
                    <li><b>Semua Juara:</b> Biaya pangkal Kedokteran khusus Rp 200.000.000 (kuota Ukridian&apos;s Family, syarat berlaku).</li>
                </ul>

                <p className='mb-3 font-semibold'>Mengapa Kompetisi Ini Berharga?</p>
                <ul className="list-disc pl-6 mb-4">
                    <li><b>Jalan Menuju Karir Teknologi </b> – Bootcamp dan workshop menyiapkan peserta untuk kompetisi nasional.</li>
                    <li><b>Investasi Pendidikan Tinggi </b>– Beasiswa UKRIDA membuka akses ke pendidikan berkualitas.</li>
                    <li><b>Pengakuan Prestasi </b>– Medali dan sertifikat memperkuat portofolio akademik.</li>
                </ul>

                <p className='mb-2 font-semibold'>Kemenangan Ini Awal Perjalanan Mereka</p>
                <p className="mb-2">Prestasi Matthew, Farisi, dan Darell membuktikan bahwa <b>pemrograman bukan sekadar hobi, tapi pintu menuju masa depan.</b> Dengan dukungan hadiah ini, mereka siap berkontribusi di dunia teknologi dan rekayasa.</p>

                <p className='mb-2 font-semibold'>📢 Ikuti Jejak Mereka!</p>
                <p className="mb-2">Saksikan momen seru kompetisi di Instagram <a className='text-blue-500' href='https://www.instagram.com/iitchallenge2024/#'>@iitchallenge2024</a>.</p>

                <p className="mb-4 font-semibold">Mari dukung generasi muda Indonesia untuk terus berinovasi! 💻🚀</p>
            </section>
        </div>
    )
}
export default CodingSeniorWinnersList